import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  propertyProjectsAndEvents: [],
  realtime__propertyProjectsAndEvents: [],

  favorite: {
    properties: [],
    events: [],
    projects: []
  },
  savedSearches: {
    properties: [],
    events: [],
    projects: []
  },
  compareList: {
    properties: [],
    events: [],
    projects: []
  },
  inquiryMessageAndRequest: {
    inquiry: [],
    message: [],
    request: []
  }
};

const notificationSlice = createSlice({
  name: 'notificationReducer',
  initialState,
  reducers: {
    //  --------------------------  propertyProjectsAndEvents --------------------------
    setAllPropertyProjectsAndEvents: (state, action) => {
      state.propertyProjectsAndEvents = action.payload;
    },
    setSinglePropertyProjectsAndEvents: (state, action) => {
      state.propertyProjectsAndEvents = [...state.propertyProjectsAndEvents, action.payload];
    },
    removeSinglePropertyProjectsAndEvents: (state, action) => {
      state.propertyProjectsAndEvents = state.propertyProjectsAndEvents.filter(
        (item) => item._id !== action.payload
      );
    },

    // add single realtime__propertyProjectsAndEvents
    addSingleRealtime__propertyProjectsAndEvents: (state, action) => {
      state.realtime__propertyProjectsAndEvents = [
        ...state.realtime__propertyProjectsAndEvents,
        action.payload
      ];
    },
    // remove all realtime__propertyProjectsAndEvents
    removeAllRealtime__propertyProjectsAndEvents: (state) => {
      state.realtime__propertyProjectsAndEvents = [];
    },

    //  --------------------------  propertyProjectsAndEvents --------------------------

    // -------------------------- favorite --------------------------
    // set all favorite
    setAllFavorite: (state, action) => {
      state.favorite = action.payload;
    },

    // remove all favorite
    removeAllFavorite: (state) => {
      state.favorite = {
        properties: [],
        events: [],
        projects: []
      };
    },
    // -------------------------- favorite --------------------------

    // -------------------------- compareList --------------------------
    // set all compareList
    setAllCompareList: (state, action) => {
      state.compareList = action.payload;
    },

    // remove all compareList
    removeAllCompareList: (state, action) => {
      if (action.payload) {
        state.compareList = {
          ...state.compareList,
          [action.payload]: []
        };
      } else {
        state.compareList = {
          properties: [],
          events: [],
          projects: []
        };
      }
    },

    // -------------------------- compareList --------------------------

    // -------------------------- saved search --------------------------
    // set all saved search
    setAllSavedSearch: (state, action) => {
      state.savedSearches = action.payload;
    },

    // remove all saved search
    removeAllSavedSearch: (state) => {
      state.savedSearches = {
        properties: [],
        events: [],
        projects: []
      };
    },
    // -------------------------- saved search --------------------------

    // -------------------------- inquiry Message And Request --------------------------
    // set all inquiry Message And Request
    setAllInquiryMessageAndRequest: (state, action) => {
      state.inquiryMessageAndRequest = action.payload;
    },

    // remove all inquiry Message And Request
    removeAllInquiryMessageAndRequest: (state) => {
      state.inquiryMessageAndRequest = {
        inquiry: [],
        message: [],
        request: []
      };
    },
    // -------------------------- inquiry Message And Request --------------------------

    // unset all notification
    unsetAllNotification: (state) => {
      state.propertyProjectsAndEvents = [];
      state.realtime__propertyProjectsAndEvents = [];
      state.favorite = {
        properties: [],
        events: [],
        projects: []
      };
      state.savedSearches = {
        properties: [],
        events: [],
        projects: []
      };
      state.compareList = {
        properties: [],
        events: [],
        projects: []
      };
      state.inquiryMessageAndRequest = {
        inquiry: [],
        message: [],
        request: []
      };
    }
  }
});

export const {
  setAllPropertyProjectsAndEvents,
  setSinglePropertyProjectsAndEvents,
  removeSinglePropertyProjectsAndEvents,
  addSingleRealtime__propertyProjectsAndEvents,
  removeAllRealtime__propertyProjectsAndEvents,
  setAllFavorite,
  removeAllFavorite,
  setAllSavedSearch,
  removeAllSavedSearch,
  unsetAllNotification,
  setAllCompareList,
  removeAllCompareList,
  setAllInquiryMessageAndRequest,
  removeAllInquiryMessageAndRequest
} = notificationSlice.actions;

export default notificationSlice.reducer;
